import type { TFunction } from 'i18next'
import { toast } from 'sonner'
import { apiErrorMessage } from '@/i18n'
import { findPermission, type PermissionCatalog } from './permissions'
import type { PermissionModule } from './types'

export function catalogText(t: TFunction, kind: 'modules' | 'resources' | 'actions', key: string) {
  const path = `access.${kind}.${key}`
  const value = t(path)
  return value === path ? key : value
}

function isCatalog(v: readonly PermissionModule[] | PermissionCatalog): v is PermissionCatalog {
  return !Array.isArray(v)
}

export function permissionLabel(
  t: TFunction,
  code: string,
  catalog: readonly PermissionModule[] | PermissionCatalog = [],
) {
  const full = isCatalog(catalog) ? catalog : null
  const modules = full ? full.modules : (catalog as readonly PermissionModule[])
  const fromBe = full?.titleByCode[code] || full?.descriptionByCode[code]
  if (fromBe) return fromBe
  const ref = findPermission(code, modules)
  return ref ? `${catalogText(t, 'resources', ref.resource.key)} · ${catalogText(t, 'actions', ref.action)}` : code
}

export function toastError(e: unknown) {
  toast.error(apiErrorMessage(e))
}
